// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"f836c806","226":"180b756b","361":"af0b4a8d","411":"e2f45d37","453":"64aababc","471":"46a51b60"}[chunkId] + ".chunk.js";
};